import PropTypes from 'prop-types'

import { isBlank } from 'utils'

import collectionProductToProductCardProps from 'converters/collectionProductToProductCardProps'

import ProductCard from 'components/ProductCard'

import { Root } from './ProductsGrid.style'

const ProductsGrid = ({ products, baseUrl }) => {
  if (isBlank(products)) return null

  return (
    <Root>
      {products.map(collectionProductToProductCardProps).map((props) => (
        <ProductCard key={props.key} {...props} baseUrl={baseUrl} />
      ))}
    </Root>
  )
}

ProductsGrid.propTypes = {
  products: PropTypes.array,
  baseUrl: PropTypes.string,
}

ProductsGrid.defaultProps = {}

export default ProductsGrid
